import { useQuery } from '@tanstack/react-query';

import {
    getTraining,
    getTrainings,
} from '@src/requests/trainings';

const useTrainingQuery = (id) => {
    return useQuery({
        queryKey: ['training', id],
        queryFn: ({ queryKey }) => getTraining(queryKey[1]),
    });
};

const useTrainingsQuery = (search) => {
    return useQuery({
        queryKey: ['trainings', search],
        queryFn: ({ queryKey }) => getTrainings(queryKey[1]),
    });
};

export {
    useTrainingQuery,
    useTrainingsQuery,
};
